module.exports = __webpack_public_path__ + "img/valvula_vg37.75ace207.jpg";